<template>
  <div class="blogpost-carousel">
    <h2 class="title-lined">
      <div class="title-line">destaques do blog</div>
    </h2>
    <vue-glide v-if="blogposts.length > 0" type="carousel" :autoplay="4000" :perView="1">
      <vue-glide-slide v-for="blogpost in blogposts" :key="blogpost.slug">
        <BlogpostCard :blogpost="blogpost"></BlogpostCard>
      </vue-glide-slide>
    </vue-glide>
  </div>
</template>

<script>
import { Glide, GlideSlide } from "vue-glide-js";
import BlogpostCard from "@/components/BlogpostCard";

export default {
  name: "BlogpostCarousel",
  props: {
    cover: String
  },
  data() {
    return {
      blogposts: []
    };
  },
  methods: {
    initialize() {
      this.$http
        .get("featured_blog.json")
        .then(response => (this.blogposts = response.data));
    }
  },
  mounted() {
    this.initialize();
  },
  components: {
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
    BlogpostCard
  }
};
</script>

<style scoped lang="sass">
.blogpost-carousel
  // margin-top: 80px
</style>
